import React from 'react'
import { observer } from 'mobx-react-lite'
import AssetListItemTitle from '../../../../../Shared/TimelineParts/AssetListItemTitle'
import AssetListItemNoteIcon from '../../../../../Shared/TimelineParts/AssetListItemNoteIcon'
import AssetListItemInlineDates, {
  AssetListItemInlineDateStatus,
} from '../../../../../Shared/TimelineParts/AssetListItemInlineDates'
import PortalKebabMenu from '../../../../../Shared/TimelineParts/PortalKebabMenu'
import EditAssetModal from './EditAssetModal'
import DeleteProjectAssetModal from './DeleteProjectAssetModal'
import { usePmAssetListItem } from './usePmAssetListItem'

const assetListItemRowStyle = { gridTemplateColumns: 'minmax(0, 1fr) auto auto' }
const assetListItemRowWithoutDatesStyle = { gridTemplateColumns: 'minmax(0, 1fr) auto' }

export default observer(function AssetListItem(props) {
  const {
    readOnly,
    asset,
    canDelete,
    showSidebarDates,
    isUsedInTimeline,
    grouped,
    note,
    dates,
    hasDateError,
    isSaving,
    editModalOpen,
    deleteModalOpen,
    isDeleting,
    campaignStartDate,
    campaignEndDate,
    currentStartDate,
    currentEndDate,
    kebabItems,
    cardClassName,
    titleVariant,
    isPassed,
    showAuthUsername,
    editModalProps,
    setEditModalOpen,
    setDeleteModalOpen,
    handleRowClick,
    handleDateChange,
    handleEditSave,
    handleDeleteConfirm,
  } = usePmAssetListItem(props)

  return (
    <div className={cardClassName} onClick={handleRowClick}>
      <div
        className="grid w-full min-w-0 items-center gap-1.5 'min-h-7"
        style={showSidebarDates ? assetListItemRowStyle : assetListItemRowWithoutDatesStyle}
      >
        <AssetListItemTitle
          asset={asset}
          variant={titleVariant}
          dimmed={isUsedInTimeline}
          passed={isPassed}
          showAuthUsername={showAuthUsername}
          grouped={grouped}
        />

        {showSidebarDates && (
          <AssetListItemInlineDates
            startDate={dates.startDate}
            endDate={dates.endDate}
            campaignStartDate={campaignStartDate}
            campaignEndDate={campaignEndDate}
            readOnly={readOnly}
            onStartDateChange={(value) => handleDateChange('startDate', value)}
            onEndDateChange={(value) => handleDateChange('endDate', value)}
          />
        )}

        <div className="flex shrink-0 items-center gap-2">
          <AssetListItemNoteIcon note={note} className={grouped ? 'text-rb-lighter-grey' : ''} />
          {kebabItems.length > 0 && <PortalKebabMenu items={kebabItems} ariaLabel="Open asset menu" />}
        </div>
      </div>

      {showSidebarDates && (
        <AssetListItemInlineDateStatus hasDateError={hasDateError} isSaving={isSaving} />
      )}

      <div onClick={(e) => e.stopPropagation()}>
        <EditAssetModal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          asset={asset}
          initialStartDate={currentStartDate}
          initialEndDate={currentEndDate}
          initialNote={note}
          initialName={asset.name}
          campaignStartDate={campaignStartDate}
          campaignEndDate={campaignEndDate}
          onSave={handleEditSave}
          {...editModalProps}
        />

        {canDelete && (
          <DeleteProjectAssetModal
            isOpen={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            assetName={asset.name}
            isDeleting={isDeleting}
            onConfirm={handleDeleteConfirm}
          />
        )}
      </div>
    </div>
  )
})
